import React, { useRef, useState, useEffect, useCallback } from 'react';
import {Container, Row, Col, Form} from 'react-bootstrap';
import { useNavigate, useLocation} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiMail, FiEye, FiEyeOff } from 'react-icons/fi';
import Cookies from 'universal-cookie';

import { ERROR_MESSAGES } from '../../data/LoginPageConstants.js';
import { getMemberFromCurrentSeasonLoggedWithPin, getMembersFromEmail} from '../../utils/redshif-data-api.js';
import { ValidationService } from '../../utils/Auth.js';
import  ErrorPage  from '../error/ErrorPage.js';
import { Header } from '../header/header.js';
import Auth from "@aws-amplify/auth";
import Userlist from '../userList/UserList.js';

import './Login.css'
import './Spinner.css'
import { Formik} from 'formik';
import * as yup from 'yup';
import { AUTH_STATE_PASS, AUTH_STATE_PIN, AUTH_STATE_PIN_PASS } from '../../data/GlobalConstants.js';

import jugador1 from '../../assets/images/RBB_2025_SSO_jugador1.png';
import jugador3 from '../../assets/images/RBB_2025_SSO_jugador3.png';

import background1 from '../../assets/images/RBB_2025_SSO_fondo_v1.jpg';
import background2 from '../../assets/images/RBB_2025_SSO_fondo_v2.jpg';
import background3 from '../../assets/images/RBB_2025_SSO_fondo_v3.jpg';


const loginPinSchema = yup.object().shape({
    pin: yup.string().required(ERROR_MESSAGES.emptyField),
    nif: yup.string().required(ERROR_MESSAGES.nifFecNac),
    fecNac: yup.date().required(ERROR_MESSAGES.nifFecNac),
});


const loginUser = yup.object().shape({
    password: yup.string().required(ERROR_MESSAGES.emptyField).min(5),
});


async function validation(token) {
    return await ValidationService.verifyJWT(token)
}


function LoginPage() {
    const [authType, setAuthType] = useState('')
    const [error, setError] = useState('');
    const [url, setURL] = useState('');
    const [dynamicURL, setDynamicURL] = useState('');
    const navigate = useNavigate()
    const [lenguage, setLanguage] = useState('es');
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [members, SetMembers] = useState(null)
    const [isValidating, setIsValidating] = useState(true);
    const [loginPin, setLoginPin] = useState(false);
    const [loginPass, setLoginPass] = useState(true);
    const [tokenReload, setTokenReload] = useState(true);
    const [pinPass, setPinPass] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [activeTab, setActiveTab] = useState('signin');
    const [randomPlayer, setRandomPlayer] = useState(null);
    const [randomBackground, setRandomBackground] = useState(null);

    const formRef = useRef();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const status = queryParams.get('status');
    const dynamicURLParam = queryParams.get('dynamicURL');
    const singUpURL = queryParams.get('singUpURL');
    const memberTypeParam = queryParams.get('memberType');

    useEffect(() => {
        if (dynamicURLParam) {
            setDynamicURL(decodeURIComponent(dynamicURLParam));
        }
    }, [dynamicURLParam, memberTypeParam]);

    useEffect(() => {
        const userId = localStorage.getItem('user_id');
        if (userId) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const numericIdRegex = /^[0-9]+$/;

            if (emailRegex.test(userId)) {
                setAuthType(AUTH_STATE_PASS);
            } else if (numericIdRegex.test(userId)) {
                setAuthType(AUTH_STATE_PIN);
            }
        }
    }, []);

    const handlePin = useCallback(() => {
        if (!loginPin) {
            setLoginPin(true);
            setTokenReload(false);
            setPinPass(true);
            setAuthType(AUTH_STATE_PIN);
        }
    }, [loginPin, setLoginPin, setTokenReload, setPinPass, setAuthType]);

    const handlePass = useCallback(() => {
        if (!loginPass) {
            setLoginPin(false);
            setTokenReload(false);
            setPinPass(true);
            setAuthType(AUTH_STATE_PASS);
        }
    }, [loginPass, setLoginPin, setTokenReload, setPinPass, setAuthType]);

    const detectInputType = useCallback((value) => {
        // Regex para validar email
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // Regex para validar ID numérico
        const numericIdRegex = /^[0-9]+$/;

        if (emailRegex.test(value)) {
            handlePass();
            return 'pass';
        } else if (numericIdRegex.test(value)) {
            handlePin();
            return 'pin';
        }
        
        return false;
    }, [handlePass, handlePin]);

    useEffect(() => {
        setIsLoading(true);
        const userId = localStorage.getItem('user_id');

        const inputType = detectInputType(userId);

        if (userId && formRef.current) {
            if (inputType === 'pin') {
                setAuthType(AUTH_STATE_PIN);    
            } else if (inputType === 'pass') {
                setAuthType(AUTH_STATE_PASS);
            }
        }
        setIsLoading(false);
    }, [detectInputType]);

    const onChangeLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };

    if (token && tokenReload) {
        validation(token).then( data => {
            setIsValidating(true);
            // setAuthType(data.payload.type);
            setURL(data.payload.retURL);
            setIsValidating(false);
        }).catch( e => {
            setIsValidating(false);
        })
        setTokenReload(false);
    }

    const handleLogin = async () => {
        var values = formRef.current.values;
        var sendedPin = document.getElementsByClassName('sendedPin')[0];
        if (sendedPin){
            sendedPin.style.display = 'none';
        }

        if (authType === AUTH_STATE_PIN) {
            const userId = localStorage.getItem('user_id');

            if (userId !== '' && values.pin !== '') {
                setError('')
                setIsLoading(true);
                if (values.nif !== '' && values.nif !== undefined){
                    values.nif = values.nif.toUpperCase();
                }
                const user = await getMemberFromCurrentSeasonLoggedWithPin(userId, values.pin, values.nif, values.fecNac).catch(e => {
                    setIsLoading(false);
                });
                if (user.length === 0) {
                    setIsLoading(false);
                    setError(ERROR_MESSAGES.invalidAuth)
                    throw new Error(ERROR_MESSAGES.invalidAuth)
                } 
                else if (user.length === 1) {
                    localStorage.removeItem('user_id');
                    setIsLoading(false);
                    const JWTarray = await ValidationService.signJWT(user[0]);
                    const cookies = new Cookies();
                    for ( var jwe of JWTarray) {
                        if (jwe.Id !== "SSO-APP") {
                            cookies.set(jwe.Id, jwe.JWE, { path: '/' , maxAge: 7200, domain: '.realbetisbalompie.es'});
                        }
                        else {
                            var jweApp = jwe.JWE;
                        }
                    }
                    setError('');
                    if (memberTypeParam) {
                        window.location.replace(`https://${url}/${memberTypeParam}/pago`);
                    } else if (dynamicURL && url) {
                        const [baseUrl, queryString] = dynamicURL.split('?');
                        const encodedQueryString = queryString ? `?${encodeURIComponent(queryString)}` : '';
                        window.location.replace(`https://${url}/${baseUrl}${encodedQueryString}`);
                    } else if (url && url !== 'App') {

                        window.location.replace(`https://${url}`);
                    } else if (url === 'App' && jweApp) {
                        window.location.replace(`/app?token=${jweApp}`);
                    } else {
                        console.error('URL or dynamicURL is missing or invalid.');
                    }
                } 
                else {
                    setIsLoading(false);
                    setError(ERROR_MESSAGES.userSameId)
                    throw new Error(ERROR_MESSAGES.userSameId)
                }
            }

        } else if (authType === AUTH_STATE_PASS || authType === AUTH_STATE_PIN_PASS) {
            setIsLoading(true);
            const username = localStorage.getItem('user_id');
            
                const user = await Auth.signIn(username, values.password)
                .catch(e => {
                    setIsLoading(false);
                    setError(ERROR_MESSAGES.userSameId)
                    throw new Error(ERROR_MESSAGES.userSameId)
                })

                if (user) {
                    localStorage.removeItem('user_id');
                    const members = await getMembersFromEmail(user.attributes.email);
                    SetMembers(members);
                    if(members.length === 0){
                        navigate('/error');
                }
            }
        }
    }

    const handleRegister = () => {
        if (memberTypeParam) {
            window.location.href = `https://socios.realbetisbalompie.es/socios/membresia/${memberTypeParam}/registro`;
        } else {
            window.location.href = `https://socios.realbetisbalompie.es/socios/membresia/registro`;
        }
    };
    
    const selectRandomPlayer = useCallback(() => {
        const players = [jugador1, jugador3];
        return players[Math.floor(Math.random() * players.length)];
    }, []);

    const selectRandomBackground = useCallback(() => {
        const backgrounds = [background1, background2, background3];
        return backgrounds[Math.floor(Math.random() * backgrounds.length)];
    }, []);

    useEffect(() => {
        setRandomPlayer(selectRandomPlayer());
        setRandomBackground(selectRandomBackground());
    }, [selectRandomPlayer, selectRandomBackground]);

    // Añadir esta función para manejar el retorno
    const handleBack = () => {
        localStorage.removeItem('user_id'); // Limpiamos el localStorage
        
        // Construimos la URL con todos los parámetros existentes
        const params = new URLSearchParams();
        if (token) params.append('token', token);
        if (dynamicURLParam) params.append('dynamicURL', dynamicURLParam);
        if (memberTypeParam) params.append('memberType', memberTypeParam);
        if (singUpURL) params.append('singUpURL', singUpURL);
        if (status) params.append('status', status);
        
        // Construimos la URL base con los parámetros
        const queryString = params.toString();
        const baseUrl = 'https://sso.realbetisbalompie.es/';
        const redirectUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;
        
        window.location.href = redirectUrl;
    };

    if (authType === AUTH_STATE_PIN) {
        return (
            <Container fluid className="componentFather">
                <Header setLanguage={onChangeLanguage} />
                <div className='bg-composition' style={{ backgroundImage: `url(${randomBackground})` }}>
                    {randomPlayer && <img src={randomPlayer} alt="Jugador Real Betis Balompie" />}
                </div>
                <div className='content-container pin'>
                    <div className="auth-tabs-container">
                        <div className="auth-tabs">
                            <button 
                                className={`tab-button ${activeTab === 'signin' ? 'active' : ''}`}
                                onClick={() => setActiveTab('signin')}
                            >
                                {t('signIn')}
                            </button>
                            <button 
                                className={`tab-button ${activeTab === 'register' ? 'active' : ''}`}
                                onClick={handleRegister}
                            >
                                {t('signUp')}
                            </button>
                        </div>
                    </div>
                    <Row className="px-4 my-5 formLogin">
                        <Col sm={4} className="resize">
                        {status && <div className="sendedPin mb-3">{t('recoverDone')} <FiMail/></div>}
                            <Formik
                            validationSchema={loginPinSchema}
                            onSubmit={handleLogin}
                            validateOnChange={false}
                            innerRef={formRef}
                            initialValues={{
                                pin: '',
                                nif: '',
                                fecNac: '',
                            }}
                            >
                            {({
                                handleSubmit,
                                handleChange,
                                handleBlur,
                                values,
                                touched,
                                isValid,
                                errors,
                            }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                {isLoading && <div class="loader mb-3"></div>}
                                {error && <div className="errorPin">
                                    {
                                        t('invalidAuth')
                                    }
                                </div>}
                                <Form.Group className="mb-5 mt-5 position-relative" controlId="formBasicNumber">
                                    <Form.Label className="fit">PIN</Form.Label>
                                    <Form.Control type="text" minLength="8" placeholder="" className="aditionalInfo"
                                        name="pin" value={values.pin} onChange={handleChange} isInvalid={!!errors.pin} />
                                    <Form.Control.Feedback className="error" type="invalid" tooltip>
                                        {t(`${errors.pin}`)}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Label className="fitInfo">* {t('info')}</Form.Label>
                                <Container className="boxAditionalInfo">
                                    <Form.Group className="mb-3 mt-5 position-relative" controlId="formBasicText">
                                        <Form.Label className="fit">{t('inputDNI')} *</Form.Label>
                                        <Form.Control type="text" minLength="8" placeholder="12345678A" className="aditionalInfo"
                                            name="nif" value={values.nif} onChange={handleChange} isInvalid={!!errors.nif && !!errors.fecNac} />
                                    </Form.Group>

                                    <Form.Group className="mb-5 mt-5 position-relative" controlId="formBasicDate">
                                        <Form.Label className="fit">{t('inputDate')} *</Form.Label>
                                        <Form.Control type="date" minLength="8" placeholder="DD/MM/AAAA" className="aditionalInfo"
                                            name="fecNac"value={values.fecNac} onChange={handleChange} isInvalid={!!errors.fecNac && !!errors.nif} />
                                        <Form.Control.Feedback className="error" type="invalid" tooltip>
                                            {t('nifFecNac')}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Container>

                                <button type="submit" className="btnLogin"
                                    onClick={handleLogin}>{t('btnLogin')}
                                </button>

                                <button type="button" className="btnRecover"
                                        onClick={() => { navigate(`/forgotpin?token=${token}`, {state: authType }) }}>{t('btnRecover')}
                                </button>

                                <button type="button" className="btnBack"
                                    onClick={handleBack}>{t('btnBack')}
                                </button>
                            </Form>
                            )}
                            </Formik>
                        </Col>
                    </Row>
                </div>
            </Container>
        )
    } else if (authType === AUTH_STATE_PASS || authType === AUTH_STATE_PIN_PASS) {
        return (
            <Container fluid className="componentFather">
                <Header setLanguage={onChangeLanguage} />
                <div className='bg-composition' style={{ backgroundImage: `url(${randomBackground})` }}>
                    {randomPlayer && <img src={randomPlayer} alt="Jugador Real Betis Balompie" />}
                </div>
                <div className='content-container'>
                    {!members && <div className="auth-tabs-container">
                        <div className="auth-tabs">
                            <button 
                                className={`tab-button ${activeTab === 'signin' ? 'active' : ''}`}
                                onClick={() => setActiveTab('signin')}
                            >
                                {t('signIn')}
                            </button>
                            <button 
                                className={`tab-button ${activeTab === 'register' ? 'active' : ''}`}
                                onClick={handleRegister}
                            >
                                {t('signUp')}
                            </button>
                        </div>
                    </div>}
                    <Row className="px-4 my-5 formLogin">
                        <Col sm={4}>
                        {status && <div className="sendedPin mb-3">{t('resetPass')}</div>}
                            <Container className="mt-5">
                            {members && <Userlist members={members} url={url} />}
                            </Container>
                            {!members && <Formik
                            validationSchema={loginUser}
                            onSubmit={handleLogin}
                            validateOnChange={false}
                            innerRef={formRef}
                            initialValues={{
                                password: '',
                            }}
                            >
                            {({
                                handleSubmit,
                                handleChange,
                                handleBlur,
                                values,
                                touched,
                                isValid,
                                errors,
                            }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                {isLoading && <div class="loader mb-3"></div>}
                                {error && <div className="errorPin">
                                    {
                                        t('invalidAuth')
                                    }
                                </div>}
                                
                                <Form.Group className="mb-5 mt-5 position-relative" controlId="formBasicPassword">
                                    <Form.Label className="fit">{t('inputPassword')}</Form.Label>
                                    <div className="password-input-wrapper">
                                        <Form.Control 
                                            type={showPassword ? "text" : "password"} 
                                            minLength="8" 
                                            placeholder="" 
                                            className="aditionalInfo"
                                            name="password" 
                                            value={values.password} 
                                            onChange={handleChange} 
                                            isInvalid={!!errors.password} 
                                        />
                                        <button 
                                            type="button" 
                                            className="password-toggle-btn" 
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <FiEyeOff /> : <FiEye />}
                                        </button>
                                    </div>
                                    <Form.Control.Feedback className="error" type="invalid" tooltip>
                                        {t('emptyField')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <button type="submit" className="btnLogin"
                                    onClick={handleLogin}>{t('btnLogin')}
                                </button>
                                <button type="button" className="btnRecover"
                                        onClick={() => { navigate(`/forgotpin?token=${token}`, {state: AUTH_STATE_PASS }) }}>{t('forgotPassword')}
                                </button>

                                <button type="button" className="btnBack"
                                    onClick={handleBack}>{t('btnBack')}
                                </button>

                            </Form>
                            )}
                            </Formik>
                        }
                        </Col>
                    </Row>
                </div>
            </Container>
        )
    } else {
        return(
            <div>
                {isValidating && <div className="loader mt-5"></div>}
                {!isValidating && <ErrorPage />}
            </div>
        )
    }
}

export default LoginPage;